import { render, staticRenderFns } from "./CpdComponent.vue?vue&type=template&id=1826c722"
import script from "./CpdComponent.vue?vue&type=script&lang=js"
export * from "./CpdComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports